import React from 'react';
import { FaRing, FaCrown, FaBirthdayCake, FaTree, FaCreditCard, FaRestroom, FaCouch, FaWheelchair, FaCocktail } from 'react-icons/fa';
import { FaAccessibleIcon, FaBaby, FaCar, FaChurch, FaFont, FaGavel, FaMoneyBillTransfer, FaPaintbrush, FaShoePrints } from 'react-icons/fa6';
import { GiHolySymbol, GiBabyBottle, GiStorkDelivery, GiBriefcase, GiLovers, GiFamilyHouse, GiPartyPopper, GiCakeSlice, GiShield, GiCrown, GiDinosaurRex, GiClown, GiMagicHat, GiTeacher, GiGraduateCap, GiDominoMask, GiHighHeel, GiSofa, GiDress, GiHotMeal, GiCarSeat, GiMusicalNotes, GiJumpingRope, GiAerialSignal, GiExitDoor, GiCigarette, GiJoystick, GiFlowerPot, GiWaterSplash, GiBarbecue, GiSuitcase, GiDramaMasks, GiPerson, GiHeadphones, GiBeerStein, GiTacos, GiBalloons, GiPaintBrush, GiCandyCanes, GiFlowers, GiPianoKeys, GiFrenchHorn, GiTrumpet, GiAccordion, GiDrum, GiSaxophone, GiCupcake, GiCarousel, GiFoodTruck, GiGamepad, GiCook, GiBabyFace, GiSewingNeedle, GiBallerinaShoes, GiLipstick, GiRobotGolem, GiVideoCamera, GiMicrophone, GiMartini, GiPhotoCamera, GiStairsCake, GiTakeMyMoney, GiPublicSpeaker, GiMirrorMirror, GiFairy, GiButterfly, GiCorn, GiNoodles } from 'react-icons/gi';
import { MdOutlineScreenShare } from 'react-icons/md';
import { FcSelfie } from "react-icons/fc";

const iconMap = {
    /** Tipos de eventos */
    'FaRing': FaRing,
    'FaCrown': FaCrown,
    'GiHolySymbol': GiHolySymbol,
    'FaBirthdayCake': FaBirthdayCake,
    'GiBabyBottle': GiBabyBottle,
    'GiStorkDelivery': GiStorkDelivery,
    'GiBriefcase': GiBriefcase,
    'FaTree': FaTree,
    'GiLovers': GiLovers,
    'GiFamilyHouse': GiFamilyHouse,
    'GiPartyPopper': GiPartyPopper,
    'GiFairy': GiFairy,          //presentacion
    'GiButterfly':GiButterfly,  //18 años
  
    /** Infantiles */
    'GiCakeSlice': GiCakeSlice,
    //'GiPartyPopper': GiPartyPopper,
    'GiShield': GiShield,
    'GiCrown': GiCrown,
    'GiDinosaurRex': GiDinosaurRex,
    'GiClown': GiClown,
    'GiMagicHat': GiMagicHat,
    'GiTeacher': GiTeacher,
  
    /** Salones */
    'GiGraduateCap': GiGraduateCap,
    'GiDominoMask': GiDominoMask,
   // 'GiBriefcase': GiBriefcase,
  
    /** Haciendas */
    'GiHighHeel': GiHighHeel,
  
    /** Amenidades Generales */
    'FaWheelchair': FaWheelchair,
    'GiSofa': GiSofa,
    'GiDress': GiDress,
    'GiHotMeal': GiHotMeal,
    'GiCarSeat': GiCarSeat,
    'FaRestroom': FaRestroom,
    'GiMusicalNotes': GiMusicalNotes,
    'GiJumpingRope': GiJumpingRope,
    'GiAerialSignal': GiAerialSignal,
    'MdOutlineScreenShare': MdOutlineScreenShare,
    'GiExitDoor': GiExitDoor,
    'FaCreditCard': FaCreditCard,
    'GiCigarette': GiCigarette,
    'FaBaby':FaBaby,
    'GiMicrophone': GiMicrophone,
    'FaAccessibleIcon': FaAccessibleIcon,
    'GiMartini':GiMartini,
    'GiTakeMyMoney':GiTakeMyMoney,
    'FaMoneyBillTransfer':FaMoneyBillTransfer,
    'GiPublicSpeaker':GiPublicSpeaker,
    'GiMirrorMirror':GiMirrorMirror,

  
    /** Infantiles (Amenidades) */
    'GiJoystick': GiJoystick,
    'FaCouch': FaCouch,
  
    /** Haciendas (Amenidades) */
    'GiFlowerPot': GiFlowerPot,
    'GiWaterSplash': GiWaterSplash,
    'GiBarbecue': GiBarbecue,
  
    /** Servicios adicionales Generales */
    'GiSuitcase': GiSuitcase,
    'GiDramaMasks': GiDramaMasks,
    'GiPerson': GiPerson,
    'GiHeadphones': GiHeadphones,
    'GiBeerStein': GiBeerStein,
    'GiTacos': GiTacos,
    'GiBalloons': GiBalloons,
    'GiPaintBrush': GiPaintBrush,
    'GiCandyCanes': GiCandyCanes,
    'GiFlowers': GiFlowers,
    'GiPianoKeys': GiPianoKeys,
    'GiFrenchHorn': GiFrenchHorn,
    'GiTrumpet': GiTrumpet,
    'GiAccordion': GiAccordion,
    'GiDrum': GiDrum,
    'GiSaxophone': GiSaxophone,
    'FaCar': FaCar,
    'GiSewingNeedle': GiSewingNeedle,
    'GiBallerinaShoes':GiBallerinaShoes,
    'GiLipstick': GiLipstick,
    'FaGavel': FaGavel,
    'FaChurch':FaChurch,
    'GiRobotGolem':GiRobotGolem,
    'GiVideoCamera':GiVideoCamera,
    'GiPhotoCamera':GiPhotoCamera,
    'GiStairsCake': GiStairsCake,
    'FaShoePrints':FaShoePrints,
    'GiCorn': GiCorn,
    'GiNoodles':GiNoodles,
    'FcSelfie': FcSelfie, 
    'FaFont': FaFont,
    'FaCocktail':FaCocktail,

    /** Infantiles (Servicios adicionales) */
    'GiCupcake': GiCupcake,
    'GiCarousel': GiCarousel,
    'FaPaintbrush': FaPaintbrush,
    'GiFoodTruck': GiFoodTruck,
    'GiGamepad': GiGamepad,
  
    /** Haciendas (Servicios adicionales) */
    'GiCook': GiCook,
    'GiBabyFace': GiBabyFace
  };
  

const getIconComponent = ({ icono, iconColor }) => {
    if (typeof icono !== 'string' || !icono.trim()) {
      console.error(`El valor de icono es inválido: ${icono}`);
      return <span className="icon-placeholder">Icono no disponible</span>;
    }
  
    if (iconColor && typeof iconColor !== 'string') {
      console.error(`El valor de iconColor es inválido: ${iconColor}`);
      return <span className="icon-placeholder">Color no válido</span>;
    }
  
    const iconoTrimmed = icono.trim();
   // console.log('icono icon:', iconoTrimmed, iconColor);
  
    const IconComponent = iconMap[iconoTrimmed];
   // console.log('IconComponent:', IconComponent);
  
    if (!IconComponent) {
      console.error(`Icono no encontrado: ${iconoTrimmed}`);
      return <span className="icon-placeholder">Icono no disponible</span>;
    }
  
    return <IconComponent className="icon" style={{ color: iconColor || "#ff9900" }} />;
  };

export { getIconComponent }; // Exporta solo la función





